export const translations = {
  ro: {
    // Navigation
    dashboard: 'Panou de Control',
    clients: 'Clienți',
    drivers: 'Șoferi',
    appointments: 'Programări',
    vinChecker: 'Verificare VIN',
    rarCounter: 'Contor RAR',
    invoices: 'Facturi',
    outreach: 'Campanii',
    promoGenerator: 'Generator Promoții',
    notifications: 'Notificări',
    receivedSms: 'SMS Primite',
    smsMessage: 'Mesaj',
    receivedAt: 'Primit la',
    next: 'Următor',
    previous: 'Înapoi',
    page: 'Pagina',
    noSms: 'Nu există SMS-uri',
    smsMessageDetails: 'Detalii Mesaj SMS',
    clickToViewFullMessage: 'Click pentru a vedea mesajul complet',
    liveLogs: 'Jurnale Live',
    settings: 'Setări',
    autoShop: 'Service Auto',
    
    // Dashboard
    totalAppointments: 'Total Programări',
    vinChecks: 'Verificări VIN',
    uniqueUsers: 'Utilizatori Unici',
    paymentRate: 'Rata de Plată',
    serviceDistribution: 'Distribuția Serviciilor',
    confirmed: 'confirmate',
    paid: 'plătite',
    noConfirmedAppointments: 'Nicio programare confirmată',
    acrossAllServices: 'Pe toate serviciile',
    ofVinChecks: 'verificări VIN',
    
    // Revenue
    revenueOverview: 'Prezentare Venituri',
    grossRevenue: 'Venit Brut',
    netRevenue: 'Venit Net',
    conversionRate: 'Rata de Conversie',
    paidVinChecks: 'verificări VIN plătite',
    afterStripeFees: 'După comisioanele Stripe (2.9%)',
    vinChecksConverted: 'Verificări VIN convertite în plătite',
    
    // Activities
    recentAppointments: 'Programări Recente',
    recentVinChecks: 'Verificări VIN Recente',
    live: 'Live',
    noRecentAppointments: 'Nicio programare recentă',
    noRecentVinChecks: 'Nicio verificare VIN recentă',
    
    // Status
    pending: 'În așteptare',
    unpaid: 'Neplătit',
    vehicleInfo: 'Info Vehicul',
    noVehicleInfo: 'Fără Info Vehicul',
    
    // Appointment Details
    appointmentDetails: 'Detalii Programare',
    shopName: 'Nume Service',
    status: 'Status',
    customerName: 'Nume Client',
    phone: 'Telefon',
    email: 'Email',
    appointmentDate: 'Data Programării',
    carMakeModel: 'Marca și Modelul Mașinii',
    registrationNumber: 'Numărul de Înmatriculare',
    specialization: 'Specializare',
    problemDescription: 'Descrierea Problemei',
    close: 'Închide',
    
    // VIN Check Details
    vinCheckDetails: 'Detalii Verificare VIN',
    vinNumber: 'Număr VIN',
    paymentStatus: 'Status Plată',
    vehicleInfoAvailable: 'Info Vehicul Disponibilă',
    createdAt: 'Creat la',
    sessionId: 'ID Sesiune',
    vehicleInformation: 'Informații Vehicul',
    yes: 'Da',
    no: 'Nu',
    
    // Settings
    languageSettings: 'Setări Limbă',
    choosePreferredLanguage: 'Alegeți limba preferată pentru interfața de administrare',
    selectInterfaceLanguage: 'Selectați Limba Interfeței',
    interfaceLanguageDescription: 'Această setare va schimba limba interfeței de administrare. Toate elementele de meniu, butoanele și mesajele vor fi afișate în limba selectată.',
    currentLanguage: 'Limba Curentă',
    saveLanguageSettings: 'Salvează Setările de Limbă',
    saving: 'Se salvează...',
    languageSettingsSaved: 'Setările de limbă au fost salvate cu succes!',
    
    // Promo Code Generator
    code: 'Cod',
    amountOff: 'Reducere Valoare',
    percentOff: 'Reducere Procent',
    duration: 'Durată',
    once: 'O dată',
    repeating: 'Repetitiv',
    forever: 'Permanent',
    generatePromoCode: 'Generează Cod Promoțional',
    generating: 'Se generează...',
    promoCodeHistory: 'Istoric Coduri Promoționale',
    ron: 'RON',
    createdBy: 'Creat de',
    by: 'De',
    created: 'Creat',
    noPromoCodes: 'Nu s-au găsit coduri promoționale.',
    failedToLoad: 'Eroare la încărcarea istoricului codurilor promoționale',
    loadingPromoCodes: 'Se încarcă codurile promoționale...',
    failedToGenerate: 'Eroare la generarea codului promoțional',
    promoCodeGenerated: 'Cod promoțional generat cu succes!',
    
    // Sidebar & TopBar
    closeSidebar: 'Închide bara laterală',
    openSidebar: 'Deschide bara laterală',
    viewNotifications: 'Vezi notificări',
    logout: 'Deconectare',
    
    // Loading
    loadingDashboard: 'Se încarcă panoul de control...',
    
    // Common
    loading: 'Se încarcă...',
    save: 'Salvează',
    cancel: 'Anulează',
    edit: 'Editează',
    delete: 'Șterge',
    view: 'Vizualizează',
    search: 'Caută',
    filter: 'Filtrează',
    export: 'Exportă',
    import: 'Importă',
    refresh: 'Reîmprospătează',
    
    // Outreach
    customerOutreach: 'Campanii Clienți',
    connectWithUnpaidCustomers: 'Conectează-te cu clienții care au verificări VIN neplătite',
    totalUnpaid: 'Total Neplătite',
    filteredResults: 'Rezultate Filtrate',
    selected: 'Selectat',
    sessionsRequiringAttention: 'Sesiuni care necesită atenție',
    matchingSearchCriteria: 'Corespund criteriilor de căutare',
    readyForOutreach: 'Gata pentru campanie',
    loadingOutreachData: 'Se încarcă datele campaniei',
    loadingUnpaidSessions: 'Se încarcă sesiunile neplătite...',
    unpaidSessions: 'Sesiuni Neplătite',
    sessions: 'sesiuni',
    searchByVinEmailPhone: 'Caută după VIN, email sau telefon...',
    noMatchingSessions: 'Nicio sesiune corespunzătoare',
    noUnpaidSessions: 'Nicio sesiune neplătită',
    adjustSearchTerms: 'Încearcă să ajustezi termenii de căutare sau șterge filtrul pentru a vedea toate sesiunile.',
    allSessionsPaid: 'Vești bune! Toate sesiunile au fost plătite.',
    unknown: 'Necunoscut',
    composeMessage: 'Compune Mesaj',
    sendingTo: 'Trimite către',
    messageTemplate: 'Șablon Mesaj',
    emailSubject: 'Subiect Email',
    enterEmailSubject: 'Introdu subiectul email...',
    messageContent: 'Conținut Mesaj',
    typeMessageHere: 'Scrie mesajul aici...',
    characters: 'caractere',
    lines: 'linii',
    sendingMessage: 'Se trimite mesajul...',
    sendMessage: 'Trimite Mesaj',
    messageSent: 'Mesaj Trimis!',
    error: 'Eroare',
    selectSession: 'Selectează o Sesiune',
    chooseCustomerSession: 'Alege o sesiune de client din listă pentru a începe să compui mesajul.',
    confirmSendMessage: 'Confirmă Trimiterea Mesajului',
    confirmSendMessageTo: 'Ești sigur că vrei să trimiți acest mesaj către',
    sendWelcomeEmailWithCredentials: 'Trimite email de bun venit cu acreditările',
    autoShopWillReceiveEmailWithLoginInstructions: 'Service-ul auto va primi un email cu instrucțiuni de conectare',
    firebaseAccountWillBeCreatedAutomatically: 'Contul Firebase va fi creat automat',
    
    // Invoices
    invoiceList: 'Lista Facturi',
    outgoingInvoices: 'Facturi Emise',
    incomingInvoices: 'Facturi Primite',
    generateInvoice: 'Generează Factură',
    invoiceNumber: 'Numărul Facturii',
    issueDate: 'Data Emiterii',
    dueDate: 'Data Scadenței',
    vatRate: 'TVA (%)',
    clientName: 'Numele Clientului',
    clientEmail: 'Email Client',
    clientAddress: 'Adresa Client',
    clientPhone: 'Telefon Client',
    productsServices: 'Produse/Servicii',
    quantity: 'Cantitate',
    price: 'Preț',
    unitPrice: 'Preț unitar',
    total: 'Total',
    subtotal: 'Subtotal',
    invoiceSummary: 'Rezumat Factură',
    createInvoice: 'Creează Factură',
    previewInvoice: 'Preview Factură',
    downloadPdf: 'Descarcă PDF',
    totalAmount: 'Suma totală',
    allInvoices: 'Toate facturile',
    totalNumberOfInvoices: 'Numărul total de facturi',
    noInvoices: 'Nicio factură',
    createFirstInvoice: 'Creează prima factură',
    generateNewInvoice: 'Generează Factură Nouă',
    billedTo: 'Facturat către',
    items: 'Articole',
    notes: 'Observații',
    footer: 'Această factură a fost generată electronic de Servicegest Admin.',
    footerContact: 'Pentru întrebări, contactați-ne la support@servicegest.ro',
    onlineAppointments: 'Programări online',
    servicegestBasic: 'Abonament Servicegest - Basic',
    customProduct: 'Produs personalizat',
    addCustomProduct: '+ Produs personalizat',
    removeItem: 'Șterge',
    draft: 'Draft',
    sent: 'Trimisă',
    actions: 'Acțiuni',
    currency: 'Monedă',
    invoice: 'FACTURĂ',
    companyInfo: 'Servicegest SRL\nBulevardul Eroilor, 43\nCluj-Napoca, România\nCUI: RO51418378',
    seller: 'Vânzător',
    buyer: 'Cumpărător',
    receivedInvoice: 'Factură Primită',
    sendToAnaf: 'Trimite către ANAF',
    
    // Invoice Series
    invoiceSeries: 'Serii Facturi',
    manageInvoiceSeries: 'Gestionează Serii Facturi',
    createNewSeries: 'Creează Serie Nouă',
    seriesName: 'Numele Seriei',
    seriesPrefix: 'Prefix Serie',
    startingNumber: 'Număr de Start',
    currentNumber: 'Număr Curent',
    isActive: 'Activ',
    createdDate: 'Data Creării',
    lastUsed: 'Ultima Utilizare',
    createSeries: 'Creează Serie',
    editSeries: 'Editează Serie',
    activateSeries: 'Activează Serie',
    deactivateSeries: 'Dezactivează Serie',
    deleteSeries: 'Șterge Serie',
    noSeries: 'Nicio serie disponibilă',
    createFirstSeries: 'Creează prima serie de facturi',
    seriesCreated: 'Seria a fost creată cu succes!',
    seriesUpdated: 'Seria a fost actualizată cu succes!',
    seriesDeleted: 'Seria a fost ștearsă cu succes!',
    confirmDeleteSeries: 'Ești sigur că vrei să ștergi această serie?',
    selectSeries: 'Selectează Serie',
    defaultSeries: 'Serie Implicită',
    active: 'Activ',
    inactive: 'Inactiv',
    never: 'Niciodată',
    enterSeriesName: 'Introdu numele seriei...',
    enterSeriesPrefix: 'Introdu prefixul seriei (ex: INV, FACT)...',
    enterStartingNumber: 'Introdu numărul de start...',
    
    // Clients
    clientsDescription: 'Gestionează baza de date a clienților și informațiile de contact',
    addClient: 'Adaugă Client',
    editClient: 'Editează Client',
    updateClient: 'Actualizează Client',
    searchClients: 'Caută clienți după nume, email, telefon sau companie...',
    client: 'Client',
    contact: 'Contact',
    company: 'Companie',
    name: 'Nume',
    address: 'Adresă',
    confirmDeleteClient: 'Ești sigur că vrei să ștergi acest client?',
    totalClients: 'Total Clienți',
    companies: 'Companii',
    individuals: 'Persoane Fizice',
    clientGrowth: 'Creștere Clienți',
    newThisMonth: 'noi luna aceasta',
    ofTotal: 'din total',
    last30Days: 'ultimele 30 zile',
    taxIdentifier: 'Cod fiscal',
    regCom: 'Nr. înregistrare',
    city: 'Oraș',
    vatPayer: 'Plătitor TVA',
    selectClient: 'Selectează client',
    invoiceDetails: 'Detalii factură',
    addItem: 'Adaugă articol',
    clientType: 'Tipul Clientului',
    individual: 'Persoană Fizică',
    business: 'Persoană Juridică',
    contactInformation: 'Informații de Contact',
    preferredContact: 'Metoda Preferată de Contact',
    emailAndPhone: 'Email și Telefon',
    businessInformation: 'Informații de Afaceri',
    addressInformation: 'Informații de Adresă',
    
    // Live Logs
    loadingLogs: 'Se încarcă jurnalele...',
    entries: 'intrări',
    allLevels: 'Toate Nivelurile',
    warnings: 'Avertismente',
    info: 'Info',
    debug: 'Debug',
    success: 'Succes',
    pause: 'Pauză',
    resume: 'Reluare',
    noLogsAvailable: 'Nu sunt disponibile jurnale',
    noLogsForFilter: 'Nu sunt jurnale pentru filtrul selectat',
    rawLog: 'Jurnal Raw',
    metadata: 'Metadata',
    
    // AutoShop specific translations
    addAutoShop: 'Adaugă Service Auto',
    editAutoShop: 'Editează Service Auto',
    updateAutoShop: 'Actualizează Service Auto',
    createAutoShopAccount: 'Creează Cont Service Auto',
    searchAutoShops: 'Caută service-uri auto după nume, email, telefon sau CUI...',
    totalAutoShops: 'Total Service-uri Auto',
    withAddress: 'Cu Adresă',
    businessEntities: 'Entități de Afaceri',
    vatPayers: 'Plătitori TVA',
    noAutoShops: 'Niciun service auto',
    getStartedByAddingAutoShop: 'Începe prin adăugarea unui service auto',
    location: 'Locație',
    businessInfo: 'Info Afaceri',
    type: 'Tip',
    confirmDeleteAutoShop: 'Ești sigur că vrei să ștergi acest service auto?',
    
    // Form fields
    brandName: 'Nume Marcă',
    accountInformation: 'Informații Cont',
    password: 'Parolă',
    confirmPassword: 'Confirmă Parola',
    additionalInfo: 'Informații Adiționale',
    userWillReceiveLoginCredentials: 'Utilizatorul va primi acreditările de conectare',
    cuiWillBeValidatedAutomatically: 'CUI-ul va fi validat automat',
    allFieldsCanBeEditedLater: 'Toate câmpurile pot fi editate ulterior',
    
    // Public Profile Management
    publicProfile: 'Profil Public',
    editPublicProfile: 'Editează Profil Public',
    managePublicShopProfile: 'Gestionează informațiile profilului public al service-ului.',
    services: 'Servicii',
    updateProfile: 'Actualizează Profil',
    
    // Marketing
    marketing: 'Marketing',

    // Parking Management
    parking: 'Parcare',
    parkingManagement: 'Gestionare Parcare',
    parkingZones: 'Zone de Parcare',
    totalParkingZones: 'Total Zone Parcare',
    activeParkingZones: 'Zone de parcare active',
    totalStreets: 'Total Străzi',
    streetsWithParking: 'Străzi cu parcare',
    averagePrice: 'Preț Mediu',
    perParkingSession: 'per sesiune de parcare',
    ourPricePerSession: 'prețul nostru per sesiune',
    averageTime: 'Timp Mediu',
    perSession: 'per sesiune',
    searchParkingZones: 'Caută zone de parcare...',
    addNewParkingZone: 'Adaugă Zonă Nouă',
    noParkingZones: 'Nu există zone de parcare',
    zoneName: 'Nume Zonă',
    smsCode: 'Cod SMS',
    smsPhone: 'Telefon SMS',
    userPrice: 'Preț Utilizator',
    ourPrice: 'Prețul Nostru',
    timeInMinutes: 'Timp (minute)',
    minutes: 'minute',
    noStreets: 'Fără străzi',
    parkingZoneDetails: 'Detalii Zonă Parcare',
    basicInformation: 'Informații de Bază',
    zoneId: 'ID Zonă',
    pricingInformation: 'Informații Preț',
    editParkingZone: 'Editează Zonă de Parcare',
    enterStreetName: 'Introduceți numele străzii',
    updateZone: 'Actualizează Zona',
    addZone: 'Adaugă Zona',
    zoneUpdatedSuccessfully: 'Zona a fost actualizată cu succes!',
    zoneAddedSuccessfully: 'Zona a fost adăugată cu succes!',
    errorSavingZone: 'Eroare la salvarea zonei',
    confirmDeleteZone: 'Ești sigur că vrei să ștergi această zonă de parcare?',
    viewDetails: 'Vezi Detalii',
    showing: 'Se afișează',
    to: 'până la',
    of: 'din',
    results: 'rezultate',
    
    // Import Excel
    importParkingZones: 'Importă Zone de Parcare',
    importFromExcel: 'Importă din Excel',
    importInstructions: 'Instrucțiuni Import',
    uploadExcelOrCSV: 'Încarcă un fișier Excel (.xlsx, .xls) sau CSV',
    requiredColumns: 'Coloane obligatorii',
    streetsSeparatedBySemicolon: 'Străzile trebuie separate prin punct și virgulă (;)',
    durationInMinutes: 'Durata este în minute',
    downloadTemplate: 'Descarcă Șablon',
    selectFile: 'Selectează Fișier',
    supportedFormats: 'Formate suportate',
    preview: 'Previzualizare',
    zones: 'zone',
    changeFile: 'Schimbă Fișier',
    startImport: 'Începe Importul',
    importing: 'Se importă',
    pleaseWaitWhileImporting: 'Te rugăm să aștepți în timp ce importăm zonele...',
    importResults: 'Rezultate Import',
    successful: 'Reușite',
    zonesImportedSuccessfully: 'zone importate cu succes',
    errors: 'Erori',
    errorParsingFile: 'Eroare la parsarea fișierului',
    noDataToImport: 'Nicio dată de importat',
    errorDuringImport: 'Eroare în timpul importului',
    itemsPerPage: 'Articole per pagină',
    totalZones: 'Total zone',
    priceInEuro: 'Prețul este în Euro (EUR)'
  },
  
  en: {
    // Navigation
    dashboard: 'Dashboard',
    clients: 'Clients',
    drivers: 'Drivers',
    appointments: 'Appointments',
    vinChecker: 'VIN Checker',
    rarCounter: 'RAR Counter',
    invoices: 'Invoices',
    outreach: 'Outreach',
    promoGenerator: 'Promo Generator',
    notifications: 'Notifications',
    receivedSms: 'Received SMS',
    smsMessage: 'Message',
    receivedAt: 'Received At',
    next: 'Next',
    previous: 'Previous',
    page: 'Page',
    noSms: 'No SMS found',
    smsMessageDetails: 'SMS Message Details',
    clickToViewFullMessage: 'Click to view full message',
    liveLogs: 'Live Logs',
    settings: 'Settings',
    autoShop: 'Auto Shop',
    
    // Dashboard
    totalAppointments: 'Total Appointments',
    vinChecks: 'VIN Checks',
    uniqueUsers: 'Unique Users',
    paymentRate: 'Payment Rate',
    serviceDistribution: 'Service Distribution',
    confirmed: 'confirmed',
    paid: 'paid',
    noConfirmedAppointments: 'No confirmed appointments',
    acrossAllServices: 'Across all services',
    ofVinChecks: 'VIN checks',
    
    // Revenue
    revenueOverview: 'Revenue Overview',
    grossRevenue: 'Gross Revenue',
    netRevenue: 'Net Revenue',
    conversionRate: 'Conversion Rate',
    paidVinChecks: 'paid VIN checks',
    afterStripeFees: 'After Stripe fees (2.9%)',
    vinChecksConverted: 'VIN checks converted to paid',
    
    // Activities
    recentAppointments: 'Recent Appointments',
    recentVinChecks: 'Recent VIN Checks',
    live: 'Live',
    noRecentAppointments: 'No recent appointments',
    noRecentVinChecks: 'No recent VIN checks',
    
    // Status
    pending: 'Pending',
    unpaid: 'Unpaid',
    vehicleInfo: 'Vehicle Info',
    noVehicleInfo: 'No Vehicle Info',
    
    // Appointment Details
    appointmentDetails: 'Appointment Details',
    shopName: 'Shop Name',
    status: 'Status',
    customerName: 'Customer Name',
    phone: 'Phone',
    email: 'Email',
    appointmentDate: 'Appointment Date',
    carMakeModel: 'Car Make & Model',
    registrationNumber: 'Registration Number',
    specialization: 'Specialization',
    problemDescription: 'Problem Description',
    close: 'Close',
    
    // VIN Check Details
    vinCheckDetails: 'VIN Check Details',
    vinNumber: 'VIN Number',
    paymentStatus: 'Payment Status',
    vehicleInfoAvailable: 'Vehicle Info Available',
    createdAt: 'Created At',
    sessionId: 'Session ID',
    vehicleInformation: 'Vehicle Information',
    yes: 'Yes',
    no: 'No',
    
    // Settings
    languageSettings: 'Language Settings',
    choosePreferredLanguage: 'Choose your preferred language for the admin interface',
    selectInterfaceLanguage: 'Select Interface Language',
    interfaceLanguageDescription: 'This setting will change the language of the admin interface. All menu items, buttons, and messages will be displayed in your selected language.',
    currentLanguage: 'Current Language',
    saveLanguageSettings: 'Save Language Settings',
    saving: 'Saving...',
    languageSettingsSaved: 'Language settings saved successfully!',
    
    // Promo Code Generator
    code: 'Code',
    amountOff: 'Amount Off',
    percentOff: 'Percent Off',
    duration: 'Duration',
    once: 'Once',
    repeating: 'Repeating',
    forever: 'Forever',
    generatePromoCode: 'Generate Promo Code',
    generating: 'Generating...',
    promoCodeHistory: 'Promo Code History',
    ron: 'RON',
    createdBy: 'Created By',
    by: 'By',
    created: 'Created',
    noPromoCodes: 'No promo codes found.',
    failedToLoad: 'Failed to load promo code history',
    loadingPromoCodes: 'Loading promo codes...',
    failedToGenerate: 'Failed to generate promo code',
    promoCodeGenerated: 'Promo code generated successfully!',
    
    // Sidebar & TopBar
    closeSidebar: 'Close sidebar',
    openSidebar: 'Open sidebar',
    viewNotifications: 'View notifications',
    logout: 'Logout',
    
    // Loading
    loadingDashboard: 'Loading dashboard...',
    
    // Common
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    refresh: 'Refresh',
    
    // Outreach
    customerOutreach: 'Customer Outreach',
    connectWithUnpaidCustomers: 'Connect with customers who have unpaid VIN checks',
    totalUnpaid: 'Total Unpaid',
    filteredResults: 'Filtered Results',
    selected: 'Selected',
    sessionsRequiringAttention: 'Sessions requiring attention',
    matchingSearchCriteria: 'Matching search criteria',
    readyForOutreach: 'Ready for outreach',
    loadingOutreachData: 'Loading outreach data',
    loadingUnpaidSessions: 'Please wait while we fetch unpaid sessions...',
    unpaidSessions: 'Unpaid Sessions',
    sessions: 'sessions',
    searchByVinEmailPhone: 'Search by VIN, email, or phone number...',
    noMatchingSessions: 'No matching sessions',
    noUnpaidSessions: 'No unpaid sessions',
    adjustSearchTerms: 'Try adjusting your search terms or clear the filter to see all sessions.',
    allSessionsPaid: 'Great news! All sessions have been paid for.',
    unknown: 'Unknown',
    composeMessage: 'Compose Message',
    sendingTo: 'Sending to',
    messageTemplate: 'Message Template',
    emailSubject: 'Email Subject',
    enterEmailSubject: 'Enter email subject...',
    messageContent: 'Message Content',
    typeMessageHere: 'Type your message here...',
    characters: 'characters',
    lines: 'lines',
    sendingMessage: 'Sending Message...',
    sendMessage: 'Send Message',
    messageSent: 'Message Sent!',
    error: 'Error',
    selectSession: 'Select a Session',
    chooseCustomerSession: 'Choose a customer session from the list to start composing your message.',
    confirmSendMessage: 'Confirm Send Message',
    confirmSendMessageTo: 'Are you sure you want to send this message to',
    sendWelcomeEmailWithCredentials: 'Send welcome email with credentials',
    autoShopWillReceiveEmailWithLoginInstructions: 'Auto shop will receive an email with login instructions',
    firebaseAccountWillBeCreatedAutomatically: 'Firebase account will be created automatically',
    
    // Invoices
    invoiceList: 'Invoice List',
    outgoingInvoices: 'Outgoing Invoices',
    incomingInvoices: 'Incoming Invoices',
    generateInvoice: 'Generate Invoice',
    invoiceNumber: 'Invoice Number',
    issueDate: 'Issue Date',
    dueDate: 'Due Date',
    vatRate: 'VAT Rate (%)',
    clientName: 'Client Name',
    clientEmail: 'Client Email',
    clientAddress: 'Client Address',
    clientPhone: 'Client Phone',
    productsServices: 'Products/Services',
    quantity: 'Quantity',
    price: 'Price',
    unitPrice: 'Unit Price',
    total: 'Total',
    subtotal: 'Subtotal',
    invoiceSummary: 'Invoice Summary',
    preview: 'Preview',
    createInvoice: 'Create Invoice',
    previewInvoice: 'Preview Invoice',
    downloadPdf: 'Download PDF',
    totalAmount: 'Total Amount',
    allInvoices: 'All Invoices',
    totalNumberOfInvoices: 'Total number of invoices',
    noInvoices: 'No invoices',
    createFirstInvoice: 'Create the first invoice',
    generateNewInvoice: 'Generate New Invoice',
    billedTo: 'Billed to',
    items: 'Items',
    notes: 'Notes',
    footer: 'This invoice was generated electronically by Servicegest Admin.',
    footerContact: 'For questions, contact us at support@servicegest.ro',
    servicegestBasic: 'Servicegest Subscription - Basic',
    customProduct: 'Custom product',
    addCustomProduct: '+ Custom product',
    removeItem: 'Remove',
    draft: 'Draft',
    sent: 'Sent',
    actions: 'Actions',
    invoice: 'INVOICE',
    currency: 'Currency',
    companyInfo: 'Servicegest SRL\nBulevardul Eroilor, 43\nCluj-Napoca, Romania\nCUI: RO51418378',
    seller: 'Seller',
    buyer: 'Buyer',
    receivedInvoice: 'Received Invoice',
    sendToAnaf: 'Send to ANAF',
    
    // Invoice Series
    invoiceSeries: 'Invoice Series',
    manageInvoiceSeries: 'Manage Invoice Series',
    createNewSeries: 'Create New Series',
    seriesName: 'Series Name',
    seriesPrefix: 'Series Prefix',
    startingNumber: 'Starting Number',
    currentNumber: 'Current Number',
    isActive: 'Active',
    createdDate: 'Created Date',
    lastUsed: 'Last Used',
    createSeries: 'Create Series',
    editSeries: 'Edit Series',
    activateSeries: 'Activate Series',
    deactivateSeries: 'Deactivate Series',
    deleteSeries: 'Delete Series',
    noSeries: 'No series available',
    createFirstSeries: 'Create the first invoice series',
    seriesCreated: 'Series created successfully!',
    seriesUpdated: 'Series updated successfully!',
    seriesDeleted: 'Series deleted successfully!',
    confirmDeleteSeries: 'Are you sure you want to delete this series?',
    selectSeries: 'Select Series',
    defaultSeries: 'Default Series',
    active: 'Active',
    inactive: 'Inactive',
    never: 'Never',
    enterSeriesName: 'Enter series name...',
    enterSeriesPrefix: 'Enter series prefix (ex: INV, FACT)...',
    enterStartingNumber: 'Enter starting number...',
    
    // Clients
    clientsDescription: 'Manage your client database and contact information',
    addClient: 'Add Client',
    editClient: 'Edit Client',
    updateClient: 'Update Client',
    searchClients: 'Search clients by name, email, phone, or company...',
    client: 'Client',
    contact: 'Contact',
    company: 'Company',
    name: 'Name',
    address: 'Address',
    confirmDeleteClient: 'Are you sure you want to delete this client?',
    totalClients: 'Total Clients',
    companies: 'Companies',
    individuals: 'Individuals',
    clientGrowth: 'Client Growth',
    newThisMonth: 'new this month',
    ofTotal: 'of total',
    last30Days: 'last 30 days',
    taxIdentifier: 'Tax Identifier',
    regCom: 'Registration Number',
    city: 'City',
    vatPayer: 'VAT Payer',
    selectClient: 'Select Client',
    invoiceDetails: 'Invoice Details',
    addItem: 'Add Item',
    clientType: 'Client Type',
    individual: 'Individual',
    business: 'Business Entity',
    contactInformation: 'Contact Information',
    preferredContact: 'Preferred Contact Method',
    emailAndPhone: 'Email and Phone',
    businessInformation: 'Business Information',
    addressInformation: 'Address Information',
    
    // Live Logs
    loadingLogs: 'Loading logs...',
    entries: 'entries',
    allLevels: 'All Levels',
    errors: 'Errors',
    warnings: 'Warnings',
    info: 'Info',
    debug: 'Debug',
    success: 'Success',
    pause: 'Pause',
    resume: 'Resume',
    noLogsAvailable: 'No logs available',
    noLogsForFilter: 'No logs for selected filter',
    rawLog: 'Raw Log',
    metadata: 'Metadata',
    
    // AutoShop specific translations
    addAutoShop: 'Add Auto Shop',
    editAutoShop: 'Edit Auto Shop',
    updateAutoShop: 'Update Auto Shop',
    createAutoShopAccount: 'Create Auto Shop Account',
    searchAutoShops: 'Search auto shops by name, email, phone, or CUI...',
    totalAutoShops: 'Total Auto Shops',
    withAddress: 'With Address',
    businessEntities: 'Business Entities',
    vatPayers: 'VAT Payers',
    noAutoShops: 'No auto shops',
    getStartedByAddingAutoShop: 'Get started by adding an auto shop',
    location: 'Location',
    businessInfo: 'Business Info',
    type: 'Type',
    confirmDeleteAutoShop: 'Are you sure you want to delete this auto shop?',
    addNewAutoShop: 'Add New Auto Shop',
    automaticDataFetching: 'Automatic Data Fetching',
    businessDataWillBeFetched: 'Business data will be automatically fetched from the Romanian tax authority',
    officialBusinessName: 'Official business name',
    registrationDetails: 'Registration details',
    vatStatus: 'VAT status',
    otherRelevantBusinessData: 'Other relevant business data',
    addingAutoShop: 'Adding...',
    addShopAccount: 'Add Shop Account',
    createFirebaseAccount: 'Create Firebase Account',
    firebaseAccountCreation: 'Firebase Account Creation',
    creatingAccount: 'Creating Account...',
    generateRandom: 'Generate Random',
    randomPasswordGenerated: 'Random password generated',
    firebaseAccountCreatedSuccessfully: 'Firebase account created successfully!',
    failedToCreateFirebaseAccount: 'Failed to create Firebase account',
    shopIdRequired: 'Shop ID is required',
    passwordMinLength: 'Password must be at least 8 characters long',
    thisWillBeTheLoginEmail: 'This will be the login email for the Firebase account',
    minimumCharactersRequired: 'Minimum 8 characters required',
    shopConfiguration: 'Shop Configuration',
    loadingConfiguration: 'Loading configuration...',
    configurationNotFound: 'Configuration not found',
    insufficientPermissions: 'Insufficient permissions',
    failedToLoadConfiguration: 'Failed to load configuration',
    noConfigurationAvailable: 'No configuration available',
    workingHours: 'Working Hours',
    onlineAppointments: 'Online Appointments',
    enabled: 'Enabled',
    disabled: 'Disabled',
    profilePicture: 'Profile Picture',
    viewImage: 'View Image',
    description: 'Description',
    detailedWorkingHours: 'Detailed Working Hours',
    closed: 'Closed',
    editConfiguration: 'Edit Configuration',
    editShopConfiguration: 'Edit Shop Configuration',
    basicSettings: 'Basic Settings',
    profileAndDescription: 'Profile & Description',
    startTime: 'Start Time',
    endTime: 'End Time',
    allowCustomersToBookOnline: 'Allow customers to book appointments online',
    calendarInterval: 'Calendar Interval',
    notificationMethod: 'Notification Method',
    profilePictureUrl: 'Profile Picture URL',
    addDay: 'Add Day',
    updating: 'Updating...',
    updateConfiguration: 'Update Configuration',
    shopConfigurationUpdated: 'Shop configuration updated successfully!',
    failedToUpdateConfiguration: 'Failed to update configuration',
    validTimeFormat: 'Please enter valid time format (HH:mm)',
    startTimeBeforeEndTime: 'Start time must be before end time',
    invalidTimeFormatInRow: 'Invalid time format in working hours row',
    startTimeBeforeEndTimeInRow: 'Start time must be before end time in working hours row',
    validProfilePictureUrl: 'Please enter a valid profile picture URL',
    noDetailedWorkingHours: 'No detailed working hours set. Click "Add Day" to add specific schedules.',
    oneHour: '1 Hour',
    thirtyMinutes: '30 Minutes',
    fifteenMinutes: '15 Minutes',
    sms: 'SMS',
    emailAndSms: 'Email & SMS',
    none: 'None',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    employeeManagement: 'Employee Management',
    manageEmployees: 'Manage Employees',
    viewAddAndManageEmployees: 'View, add, and manage employees for this auto shop.',
    addEmployee: 'Add Employee',
    addNewEmployee: 'Add New Employee',
    addFirstEmployee: 'Add First Employee',
    noEmployees: 'No Employees',
    getStartedByAddingEmployee: 'Get started by adding your first employee.',
    employees: 'Employees',
    errorLoadingEmployees: 'Error Loading Employees',
    insufficientPermissionsEmployees: 'Insufficient permissions to view employees',
    failedToLoadEmployees: 'Failed to load employees',
    loadingEmployees: 'Loading employees...',
    tryAgain: 'Try Again',
    editEmployee: 'Edit Employee',
    deleteEmployee: 'Delete Employee',
    employeeInformation: 'Employee Information',
    fullName: 'Full Name',
    mechanic: 'Mechanic',
    electrician: 'Electrician',
    bodyworkSpecialist: 'Bodywork Specialist',
    diagnosticsSpecialist: 'Diagnostics Specialist',
    manager: 'Manager',
    apprentice: 'Apprentice',
    addSchedule: 'Add Schedule',
    noWorkingHoursSet: 'No working hours set. Click "Add Schedule" to add employee\'s schedule.',
    addingEmployee: 'Adding Employee...',
    employeeAddedSuccessfully: 'Employee added successfully!',
    failedToAddEmployee: 'Failed to add employee',
    pleaseEnterEmployeeName: 'Please enter employee name',
    pleaseEnterEmployeeEmail: 'Please enter employee email',
    pleaseEnterEmployeePhone: 'Please enter employee phone number',
    noScheduleSet: 'No schedule set',
    
    // Public Profile Management
    publicProfile: 'Public Profile',
    editPublicProfile: 'Edit Public Profile',
    managePublicShopProfile: 'Manage your shop\'s public profile information.',
    services: 'Services',
    updateProfile: 'Update Profile',
    
    // Form fields
    brandName: 'Brand Name',
    accountInformation: 'Account Information',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    additionalInfo: 'Additional Information',
    userWillReceiveLoginCredentials: 'User will receive login credentials',
    cuiWillBeValidatedAutomatically: 'CUI will be validated automatically',
    allFieldsCanBeEditedLater: 'All fields can be edited later',
    
    // Marketing
    marketing: 'Marketing',

    // Parking Management
    parking: 'Parking',
    parkingManagement: 'Parking Management',
    parkingZones: 'Parking Zones',
    totalParkingZones: 'Total Parking Zones',
    activeParkingZones: 'Active parking zones',
    totalStreets: 'Total Streets',
    streetsWithParking: 'Streets with parking',
    averagePrice: 'Average Price',
    perParkingSession: 'per parking session',
    ourPricePerSession: 'our price per session',
    averageTime: 'Average Time',
    perSession: 'per session',
    searchParkingZones: 'Search parking zones...',
    addNewParkingZone: 'Add New Parking Zone',
    noParkingZones: 'No parking zones',
    zoneName: 'Zone Name',
    smsCode: 'SMS Code',
    smsPhone: 'SMS Phone',
    userPrice: 'User Price',
    ourPrice: 'Our Price',
    parkingZoneDetails: 'Parking Zone Details',
    basicInformation: 'Basic Information',
    zoneId: 'Zone ID',
    pricingInformation: 'Pricing Information',
    editParkingZone: 'Edit Parking Zone',
    enterStreetName: 'Enter street name',
    updateZone: 'Update Zone',
    addZone: 'Add Zone',
    zoneUpdatedSuccessfully: 'Zone updated successfully!',
    zoneAddedSuccessfully: 'Zone added successfully!',
    errorSavingZone: 'Error saving zone',
    confirmDeleteZone: 'Are you sure you want to delete this parking zone?',
    viewDetails: 'View Details',
    
    // Import Excel
    importParkingZones: 'Import Parking Zones',
    importFromExcel: 'Import from Excel',
    importInstructions: 'Import Instructions',
    uploadExcelOrCSV: 'Upload an Excel (.xlsx, .xls) or CSV file',
    requiredColumns: 'Required columns',
    streetsSeparatedBySemicolon: 'Streets must be separated by semicolon (;)',
    durationInMinutes: 'Duration is in minutes',
    downloadTemplate: 'Download Template',
    selectFile: 'Select File',
    supportedFormats: 'Supported formats',
    zones: 'zones',
    changeFile: 'Change File',
    startImport: 'Start Import',
    importing: 'Importing',
    pleaseWaitWhileImporting: 'Please wait while we import the zones...',
    importResults: 'Import Results',
    successful: 'Successful',
    zonesImportedSuccessfully: 'zones imported successfully',
    errorParsingFile: 'Error parsing file',
    noDataToImport: 'No data to import',
    errorDuringImport: 'Error during import',
    itemsPerPage: 'Items per page',
    totalZones: 'Total zones',
    priceInEuro: 'Price is in Euro (EUR)'
  },
  
  hu: {
    // Navigation
    dashboard: 'Irányítópult',
    clients: 'Ügyfelek',
    drivers: 'Sofőrök',
    appointments: 'Időpontok',
    vinChecker: 'VIN Ellenőrző',
    rarCounter: 'RAR Számláló',
    invoices: 'Számlák',
    outreach: 'Kampányok',
    promoGenerator: 'Promóció Generátor',
    notifications: 'Értesítések',
    receivedSms: 'Beérkezett SMS',
    smsMessage: 'Üzenet',
    receivedAt: 'Érkezett',
    next: 'Következő',
    previous: 'Előző',
    page: 'Oldal',
    noSms: 'Nincsenek SMS-ek',
    smsMessageDetails: 'SMS Üzenet Részletek',
    clickToViewFullMessage: 'Kattintson a teljes üzenet megtekintéséhez',
    liveLogs: 'Élő Naplók',
    settings: 'Beállítások',
    autoShop: 'Autószerviz',
    
    // Dashboard
    totalAppointments: 'Összes Időpont',
    vinChecks: 'VIN Ellenőrzések',
    uniqueUsers: 'Egyedi Felhasználók',
    paymentRate: 'Fizetési Arány',
    serviceDistribution: 'Szolgáltatás Eloszlás',
    confirmed: 'megerősített',
    paid: 'fizetett',
    noConfirmedAppointments: 'Nincs megerősített időpont',
    acrossAllServices: 'Minden szolgáltatás',
    ofVinChecks: 'VIN ellenőrzés',
    
    // Revenue
    revenueOverview: 'Bevétel Áttekintés',
    grossRevenue: 'Bruttó Bevétel',
    netRevenue: 'Nettó Bevétel',
    conversionRate: 'Konverziós Arány',
    paidVinChecks: 'fizetett VIN ellenőrzés',
    afterStripeFees: 'Stripe díjak után (2.9%)',
    vinChecksConverted: 'VIN ellenőrzések fizetettre konvertálva',
    
    // Activities
    recentAppointments: 'Legutóbbi Időpontok',
    recentVinChecks: 'Legutóbbi VIN Ellenőrzések',
    live: 'Élő',
    noRecentAppointments: 'Nincs legutóbbi időpont',
    noRecentVinChecks: 'Nincs legutóbbi VIN ellenőrzés',
    
    // Status
    pending: 'Függőben',
    unpaid: 'Nem fizetett',
    vehicleInfo: 'Jármű Info',
    noVehicleInfo: 'Nincs Jármű Info',
    
    // Appointment Details
    appointmentDetails: 'Időpont Részletek',
    shopName: 'Szerviz Neve',
    status: 'Állapot',
    customerName: 'Ügyfél Neve',
    phone: 'Telefon',
    email: 'Email',
    appointmentDate: 'Időpont Dátuma',
    carMakeModel: 'Autó Márka és Modell',
    registrationNumber: 'Rendszám',
    specialization: 'Specializáció',
    problemDescription: 'Probléma Leírása',
    close: 'Bezárás',
    
    // VIN Check Details
    vinCheckDetails: 'VIN Ellenőrzés Részletek',
    vinNumber: 'VIN Szám',
    paymentStatus: 'Fizetési Állapot',
    vehicleInfoAvailable: 'Jármű Info Elérhető',
    createdAt: 'Létrehozva',
    sessionId: 'Munkamenet ID',
    vehicleInformation: 'Jármű Információk',
    yes: 'Igen',
    no: 'Nem',
    
    // Settings
    languageSettings: 'Nyelv Beállítások',
    choosePreferredLanguage: 'Válassza ki a preferált nyelvet az admin felülethez',
    selectInterfaceLanguage: 'Felület Nyelvének Kiválasztása',
    interfaceLanguageDescription: 'Ez a beállítás megváltoztatja az admin felület nyelvét. Minden menüelem, gomb és üzenet a kiválasztott nyelven jelenik meg.',
    currentLanguage: 'Jelenlegi Nyelv',
    saveLanguageSettings: 'Nyelv Beállítások Mentése',
    saving: 'Mentés...',
    languageSettingsSaved: 'Nyelv beállítások sikeresen mentve!',
    
    // Promo Code Generator
    code: 'Kód',
    amountOff: 'Összeg Kedvezmény',
    percentOff: 'Százalék Kedvezmény',
    duration: 'Időtartam',
    once: 'Egyszer',
    repeating: 'Ismétlődő',
    forever: 'Örökké',
    generatePromoCode: 'Promóciós Kód Generálása',
    generating: 'Generálás...',
    promoCodeHistory: 'Promóciós Kód Előzmények',
    ron: 'RON',
    createdBy: 'Létrehozta',
    by: 'Által',
    created: 'Létrehozva',
    noPromoCodes: 'Nem található promóciós kód.',
    failedToLoad: 'Nem sikerült betölteni a promóciós kód előzményeket',
    loadingPromoCodes: 'Promóciós kódok betöltése...',
    failedToGenerate: 'Nem sikerült létrehozni a promóciós kódot',
    promoCodeGenerated: 'Promóciós kód sikeresen létrehozva!',
    
    // Sidebar & TopBar
    closeSidebar: 'Oldalsáv bezárása',
    openSidebar: 'Oldalsáv megnyitása',
    viewNotifications: 'Értesítések megtekintése',
    logout: 'Kijelentkezés',
    
    // Loading
    loadingDashboard: 'Irányítópult betöltése...',
    
    // Common
    loading: 'Betöltés...',
    save: 'Mentés',
    cancel: 'Mégse',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    view: 'Megtekintés',
    search: 'Keresés',
    filter: 'Szűrés',
    export: 'Exportálás',
    import: 'Importálás',
    refresh: 'Frissítés',
    
    // Outreach
    customerOutreach: 'Ügyfél Kampány',
    connectWithUnpaidCustomers: 'Kapcsolódj azokhoz az ügyfelekhez, akiknek fizetetlen VIN ellenőrzései vannak',
    totalUnpaid: 'Összes Fizetetlen',
    filteredResults: 'Szűrt Eredmények',
    selected: 'Kiválasztott',
    sessionsRequiringAttention: 'Figyelmet igénylő munkamenetek',
    matchingSearchCriteria: 'Keresési feltételeknek megfelelő',
    readyForOutreach: 'Kampányra kész',
    loadingOutreachData: 'Kampány adatok betöltése',
    loadingUnpaidSessions: 'Kérjük várjon, míg betöltjük a fizetetlen munkameneteket...',
    unpaidSessions: 'Fizetetlen Munkamenetek',
    sessions: 'munkamenet',
    searchByVinEmailPhone: 'Keresés VIN, email vagy telefonszám szerint...',
    noMatchingSessions: 'Nincs megfelelő munkamenet',
    noUnpaidSessions: 'Nincs fizetetlen munkamenet',
    adjustSearchTerms: 'Próbálja meg módosítani a keresési kifejezéseket vagy törölje a szűrőt az összes munkamenet megtekintéséhez.',
    allSessionsPaid: 'Nagyszerű hírek! Minden munkamenet ki lett fizetve.',
    unknown: 'Ismeretlen',
    composeMessage: 'Üzenet Írása',
    sendingTo: 'Küldés címzett',
    messageTemplate: 'Üzenet Sablon',
    emailSubject: 'Email Tárgy',
    enterEmailSubject: 'Adja meg az email tárgyát...',
    messageContent: 'Üzenet Tartalom',
    typeMessageHere: 'Írja be az üzenetét ide...',
    characters: 'karakter',
    lines: 'sor',
    sendingMessage: 'Üzenet Küldése...',
    sendMessage: 'Üzenet Küldése',
    messageSent: 'Üzenet Elküldve!',
    error: 'Hiba',
    selectSession: 'Munkamenet Kiválasztása',
    chooseCustomerSession: 'Válasszon egy ügyfél munkamenetet a listából az üzenet írásának megkezdéséhez.',
    confirmSendMessage: 'Üzenet Küldés Megerősítése',
    confirmSendMessageTo: 'Biztosan el szeretné küldeni ezt az üzenetet',
    sendWelcomeEmailWithCredentials: 'Üdvözlő email küldése hitelesítő adatokkal',
    autoShopWillReceiveEmailWithLoginInstructions: 'Az autószerviz emailt kap bejelentkezési utasításokkal',
    firebaseAccountWillBeCreatedAutomatically: 'A Firebase fiók automatikusan létrejön',
    
    // Invoices
    invoiceList: 'Számla Lista',
    outgoingInvoices: 'Kimenő Számlák',
    incomingInvoices: 'Bejövő Számlák',
    generateInvoice: 'Számla Generálása',
    invoiceNumber: 'Számla Szám',
    issueDate: 'Kiállítás Dátuma',
    dueDate: 'Esedékesség Dátuma',
    vatRate: 'ÁFA (%)',
    clientName: 'Ügyfél Neve',
    clientEmail: 'Ügyfél Email',
    clientAddress: 'Ügyfél Címe',
    clientPhone: 'Ügyfél Telefon',
    productsServices: 'Termékek/Szolgáltatások',
    description: 'Leírás',
    quantity: 'Mennyiség',
    price: 'Ár',
    unitPrice: 'Egységár',
    total: 'Összesen',
    subtotal: 'Részösszeg',
    invoiceSummary: 'Számla Összefoglaló',
    preview: 'Előnézet',
    createInvoice: 'Számla Létrehozása',
    previewInvoice: 'Számla Előnézet',
    downloadPdf: 'PDF Letöltés',
    totalAmount: 'Teljes Összeg',
    allInvoices: 'Minden Számla',
    totalNumberOfInvoices: 'Számlák teljes száma',
    noInvoices: 'Nincsenek számlák',
    createFirstInvoice: 'Első számla létrehozása',
    generateNewInvoice: 'Új Számla Generálása',
    billedTo: 'Számlázott',
    items: 'Tételek',
    notes: 'Megjegyzések',
    footer: 'Ez a számla elektronikusan lett generálva a Servicegest Admin által.',
    footerContact: 'Kérdések esetén lépjen kapcsolatba velünk: support@servicegest.ro',
    onlineAppointments: 'Online időpontok',
    servicegestBasic: 'Servicegest Előfizetés - Alap',
    customProduct: 'Egyedi termék',
    addCustomProduct: '+ Egyedi termék',
    removeItem: 'Eltávolítás',
    draft: 'Vázlat',
    sent: 'Elküldött',
    actions: 'Műveletek',
    invoice: 'SZÁMLA',
    currency: 'Pénznem',
    companyInfo: 'Servicegest SRL\nBulevardul Eroilor, 43\nCluj-Napoca, Románia\nCUI: RO51418378',
    seller: 'Eladó',
    buyer: 'Vevő',
    receivedInvoice: 'Kiadott számla',
    sendToAnaf: 'Küldés az ANAF-hoz',
    
    // Invoice Series
    invoiceSeries: 'Számla Sorozatok',
    manageInvoiceSeries: 'Számla Sorozatok Kezelése',
    createNewSeries: 'Új Sorozat Létrehozása',
    seriesName: 'Sorozat Neve',
    seriesPrefix: 'Sorozat Prefix',
    startingNumber: 'Kezdő Szám',
    currentNumber: 'Jelenlegi Szám',
    isActive: 'Aktív',
    createdDate: 'Létrehozás Dátuma',
    lastUsed: 'Utoljára Használt',
    createSeries: 'Sorozat Létrehozása',
    editSeries: 'Sorozat Szerkesztése',
    activateSeries: 'Sorozat Aktiválása',
    deactivateSeries: 'Sorozat Deaktiválása',
    deleteSeries: 'Sorozat Törlése',
    noSeries: 'Nincs elérhető sorozat',
    createFirstSeries: 'Első számla sorozat létrehozása',
    seriesCreated: 'Sorozat sikeresen létrehozva!',
    seriesUpdated: 'Sorozat sikeresen frissítve!',
    seriesDeleted: 'Sorozat sikeresen törölve!',
    confirmDeleteSeries: 'Biztosan törölni szeretné ezt a sorozatot?',
    selectSeries: 'Sorozat Kiválasztása',
    defaultSeries: 'Alapértelmezett Sorozat',
    active: 'Aktív',
    inactive: 'Inaktív',
    never: 'Soha',
    enterSeriesName: 'Adja meg a sorozat nevét...',
    enterSeriesPrefix: 'Adja meg a sorozat prefixét (pl: INV, FACT)...',
    enterStartingNumber: 'Adja meg a kezdő számot...',
    
    // Clients
    clientsDescription: 'Kezelje az ügyfél adatbázist és kapcsolattartási információkat',
    addClient: 'Ügyfél Hozzáadása',
    editClient: 'Ügyfél Szerkesztése',
    updateClient: 'Ügyfél Frissítése',
    searchClients: 'Ügyfelek keresése név, email, telefon vagy cég szerint...',
    client: 'Ügyfél',
    contact: 'Kapcsolat',
    company: 'Cég',
    name: 'Név',
    address: 'Cím',
    confirmDeleteClient: 'Biztosan törölni szeretné ezt az ügyfelet?',
    totalClients: 'Összes Ügyfél',
    companies: 'Cégek',
    individuals: 'Magánszemélyek',
    clientGrowth: 'Ügyfél Növekedés',
    newThisMonth: 'új ezen a hónapon',
    ofTotal: 'az összesből',
    last30Days: 'utolsó 30 nap',
    taxIdentifier: 'Adóazonosító',
    regCom: 'Cégjegyzékszám',
    city: 'Város',
    vatPayer: 'ÁFA alany',
    selectClient: 'Ügyfél Kiválasztása',
    invoiceDetails: 'Számla Részletek',
    addItem: 'Tétel Hozzáadása',
    clientType: 'Ügyfél Típusa',
    individual: 'Magánszemély',
    business: 'Gazdasági Társaság',
    contactInformation: 'Kapcsolattartási Információk',
    preferredContact: 'Előnyben Részesített Kapcsolattartási Mód',
    emailAndPhone: 'Email és Telefon',
    businessInformation: 'Üzleti Információk',
    addressInformation: 'Cím Információk',
    
    // Live Logs
    loadingLogs: 'Naplók betöltése...',
    entries: 'bejegyzés',
    allLevels: 'Minden Szint',
    errors: 'Hibák',
    warnings: 'Figyelmeztetések',
    info: 'Info',
    debug: 'Debug',
    success: 'Siker',
    pause: 'Szünet',
    resume: 'Folytatás',
    noLogsAvailable: 'Nincsenek elérhető naplók',
    noLogsForFilter: 'Nincsenek naplók a kiválasztott szűrőhöz',
    rawLog: 'Nyers Napló',
    metadata: 'Metaadat',
    
    // AutoShop specific translations
    addAutoShop: 'Autószerviz Hozzáadása',
    editAutoShop: 'Autószerviz Szerkesztése',
    updateAutoShop: 'Autószerviz Frissítése',
    createAutoShopAccount: 'Autószerviz Fiók Létrehozása',
    searchAutoShops: 'Autószervizek keresése név, email, telefon vagy CUI szerint...',
    totalAutoShops: 'Összes Autószerviz',
    withAddress: 'Címmel',
    businessEntities: 'Gazdasági Társaságok',
    vatPayers: 'ÁFA Alanyok',
    noAutoShops: 'Nincsenek autószervizek',
    getStartedByAddingAutoShop: 'Kezdjen egy autószerviz hozzáadásával',
    location: 'Helyszín',
    businessInfo: 'Üzleti Info',
    type: 'Típus',
    confirmDeleteAutoShop: 'Biztosan törölni szeretné ezt az autószervizt?',
    
    // Form fields
    brandName: 'Márka Név',
    accountInformation: 'Fiók Információk',
    password: 'Jelszó',
    confirmPassword: 'Jelszó Megerősítése',
    additionalInfo: 'További Információk',
    userWillReceiveLoginCredentials: 'A felhasználó megkapja a bejelentkezési adatokat',
    cuiWillBeValidatedAutomatically: 'A CUI automatikusan érvényesítésre kerül',
    allFieldsCanBeEditedLater: 'Minden mező senere szerkeszthető',
    
    // Public Profile Management
    publicProfile: 'Nyilvános Profil',
    editPublicProfile: 'Nyilvános Profil Szerkesztése',
    managePublicShopProfile: 'A szerviz nyilvános profil információinak kezelése.',
    services: 'Szolgáltatások',
    updateProfile: 'Profil Frissítése'
  }
};
